import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './vuetify'
import moment from 'moment'

const app = createApp(App)

app.config.globalProperties.$filters = {
    capitalize(str) {
		if (!str) return ''
		str = str.toString()
		return str.charAt(0).toUpperCase() + str.slice(1)
	},

    translate(str) {
		let t = vuetify.locale.t(`$vuetify.${str}`)

		return t === `$vuetify.${str}` ? str : t
	},

	Translate(str) {
		return this.capitalize(this.translate(str));
	},

	dateFormat(value, format = 'DD.MM.YYYY') {
		//console.log('main.js', 'dateFormat', 'value', value)

		format = format ? format : 'DD.MM.YYYY'

		if (value) {
			if (Number.isInteger(value)) {
				return moment.unix(value).format(format)
			}
			return moment(String(value)).format(format)
		}
	},
}

app.use(store).use(router).use(vuetify).mount('#app')
